export const SAVE = 'stepBankDetails.SAVE';
export const VALUE_CHANGED = 'stepBankDetails.VALUE_CHANGED';
export const LOAD = 'stepBankDetails.VALUE_LOAD';
export const NEXT = 'stepBankDetails.NEXT';
export const RESET = 'stepBankDetails.RESET';
export const RESET_REGISTER_GST_STATE = 'stepBankDetails.RESET_REGISTER_GST_STATE';
export const CLOSE_BSB_NOTICE = 'stepBankDetails.CLOSE_BSB_NOTICE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepBankDetails/constants.js